import React, { useState, useEffect, } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useClearCache } from 'react-clear-cache';
import axios from "axios";
import { Col, Container, Content, FlexboxGrid, Header, Navbar, } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { MainLogo } from "../utils/icons";
import { useIsMobile } from "../utils/useIsMobile";
import Catalog from 'components/Catalog.js';
import image from "assets/img/full-screen-image-2.jpg";
import loader from "assets/img/init.svg";
import r404 from "assets/img/404.svg";
import r403 from "assets/img/403.svg";
import r500 from "assets/img/500.svg";
import r503 from "assets/img/503.svg";

function CatalogView() {
    const site = useSelector(state => state.site);
    const history = useHistory();
    const [articulos, setArticulos] = useState([]);
    const [reportTitle, setReportTitle] = useState("");
    const [groupType, setGroupType] = useState(0);
    const [proyectUser, setProyectUser] = useState({});
    const [validityTo, setValidityTo] = useState('');
    const [loadingState, setLoadingState] = useState(0);
    const [currentState, setCurrentState] = useState("buscando catálogo ...");
    const [cookies, setCookie] = useCookies(['uuid']);
    const screenSize = useIsMobile();
    const { isLatestVersion, emptyCacheStorage } = useClearCache();

    useEffect(() => {
        if (site.site != null && screenSize.isMobile && site.site.responsiveType === '1') {
            history.push(window.location.pathname.replace('/vc/', '/vl/'));
        } else if (site.site != null && !screenSize.isMobile && site.site.responsiveType === '1') {
            history.push(window.location.pathname.replace('/vl/', '/vc/'));
        }
    }, [screenSize.isMobile]);

    useEffect(() => {
        console.log('useEffect begin');
        if (!isLatestVersion) {
            emptyCacheStorage();
            return () => { console.log('useEffect refresh'); };
        }
        const source = axios.CancelToken.source();
        const uuid = cookies.uuid ? cookies.uuid : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
        if (!cookies.uuid)
            setCookie('uuid', uuid, { path: '/', sameSite: 'none', domain: '.wisesoft.ar', secure: true, expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)) });
        const fetchData = async () => {
            await axios
                .get(`${site.site.apiServer}/catalogo/view${window.location.pathname}`, { withCredentials: true })
                .then(async (response) => {
                    if (response.data.result) {
                        setCurrentState("iniciando ...");
                        setReportTitle(response.data.header);
                        setGroupType(response.data.groupType);
                        setArticulos(response.data.data);
                        setValidityTo(response.data.validityTo);
                        setProyectUser({
                            printUser: response.data.printUser,
                            contactEmail: response.data.contactEmail,
                            contactName: response.data.contactName,
                            contactPhone: response.data.contactPhone
                        });
                        setTimeout(() => { setLoadingState(1); }, 500);
                    } else {
                        setLoadingState(-4);
                    }
                })
                .catch((e) => {
                    if (e.response && e.response.data && e.response.data.detail === 'NOT_FOUND') {
                        setLoadingState(-1);
                    } else if (e.response && e.response.data && e.response.data.detail === 'EXPIRED') {
                        setLoadingState(-2);
                    } else if (e.response && e.response.data && e.response.data.detail === 'INACTIVE') {
                        setLoadingState(-3);
                    } else {
                        setLoadingState(-4);
                    }
                });
        }
        fetchData();
        return () => { if (source) source.cancel('change view'); console.log('useEffect end'); }
    }, []);

    return (
        <div className="wrapper wrapper-full-page">
            <div className="full-page section-image" data-color="black">
                <Container>
                    <Content style={{ padding: "20px" }}>
                        {loadingState === 0 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} colspan={24} md={5} style={{ color: "#fff" }}>
                                    <img src={loader} style={{ display: "block", margin: "auto", width: 150 }} alt="loading" />
                                    <h5 style={{ marginTop: 20, fontWeight: "normal", textAlign: "center" }}>{currentState}</h5>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === 1 && (<Catalog key="wise_catalog" articulos={articulos} groupType={groupType} headerText={reportTitle} httpOnly={true} proyectUser={proyectUser} validityTo={validityTo} /> )}
                        {loadingState === -1 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r404} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>No se encontró el catálogo solicitado</h4>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === -2 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r403} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>Expiró la vigencia del catálogo solicitado</h4>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === -3 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r503} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>La publicación se encuentra en pausa...</h4>
                                    <h5 style={{ marginTop: 10, textAlign: "center", opacity: .6, fontWeight: "normal" }}>Por favor, intente ingresar nuevamente en unos instantes.</h5>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                        {loadingState === -4 && (
                            <FlexboxGrid justify="center">
                                <FlexboxGrid.Item as={Col} md={8} style={{ color: "#fff" }}>
                                    <img src={r500} style={{ display: "block", margin: "auto", width: 300, opacity: .3 }} alt="loading" />
                                    <h4 style={{ marginTop: 30, textAlign: "center", opacity: .6 }}>Pedimos disculpas, el servidor no está respondiendo...</h4>
                                    <h5 style={{ marginTop: 10, textAlign: "center", opacity: .6, fontWeight: "normal" }}>Por favor, intente ingresar nuevamente en unos instantes.</h5>
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        )}
                    </Content>
                </Container>
                <div className="full-page-background" style={{ backgroundImage: `url(${image})` }}></div>
            </div>
        </div>
    );

}
export default CatalogView;